export default __webpack_public_path__ + "static/media/times.486d740d.svg";